// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "segments-1TCAO";
var _3 = "passengers-1bD6Q";
export { _1 as "__esModule", _2 as "segments", _3 as "passengers" }
export default { "__esModule": _1, "segments": _2, "passengers": _3 }
